module.exports = __webpack_public_path__ + "static/media/VectorPointInacabado6.ec22fec5.svg";